import { FileVideo, Radio } from 'lucide-react'
import { useViewActive } from '../viewActivity'
import { HomeStartScene } from './HomeStartScene'

export function HomeStart({ paused, onUpload, onLive }: { paused: boolean; onUpload: () => void; onLive: () => void }) {
  const active = useViewActive()

  return <div className="home-start" data-active={active && !paused}>
    <HomeStartScene active={active && !paused} />
    <div className="home-start-ribbons" aria-hidden="true"><span /><span /><span /></div>
    <div className="home-start-center">
      <span className="home-start-logo" role="img" aria-label="Motion" />
      <div className="home-start-actions" role="group" aria-label="Add a source">
        <button className="home-start-action" type="button" aria-label="Upload a recording" onClick={onUpload}>
          <FileVideo className="home-start-icon" size={18} strokeWidth={1.5} aria-hidden="true" />
          <span className="home-start-label">Upload</span>
        </button>
        <button className="home-start-action" type="button" aria-label="Connect a live stream" onClick={onLive}>
          <Radio className="home-start-icon" size={18} strokeWidth={1.5} aria-hidden="true" />
          <span className="home-start-label">Go Live</span>
        </button>
      </div>
    </div>
  </div>
}
